/**
 * Short-turn help-sheet spacing profile.
 *
 * These values are intentionally optically tuned per help-sheet mode.
 * Keep this map in sync with `/dev/short-turn-help-sheet-audit`.
 */
export const SHORT_TURN_HELP_SHEET_CALLOUT_TOP_SPACING = {
  minimumRest: 'mt-4',
  surchargePeriod: 'mt-3',
  carryOver: 'mt-2',
  bumpUp: 'mt-2',
  fixedStart: 'mt-2',
  guaranteedRate: 'mt-2',
  fixedPremium: 'mt-3',
  hourlyPremiumGroup: 'mt-3',
  extendedOvertimeGroup: 'mt-3',
} as const;

